/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    MoyaComponents.register('carousel', [
        'https://unpkg.com/swiper/swiper-bundle.min.js',
    ], function (el) {
        var selector = '#' + el.id + ' .swiper-container';
        var selectorItem = document.querySelector(selector);
        var swiperParams = {
            direction: 'horizontal',
            loopAdditionalSlides: 2,
            loop: true,
        };
        if (parseInt(selectorItem.getAttribute('data-swiper-slides-per-view')) > 0) {
            swiperParams.slidesPerView = parseInt(selectorItem.getAttribute('data-swiper-slides-per-view'));
        }
        if (parseInt(selectorItem.getAttribute('data-swiper-space-between')) > 0) {
            swiperParams.spaceBetween = parseInt(selectorItem.getAttribute('data-swiper-space-between'));
        }
        else {
            swiperParams.slidesPerView = 1;
        }
        if (selectorItem.getAttribute('data-swiper-nav')) {
            swiperParams.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };
        }
        if (selectorItem.getAttribute('data-swiper-pagination')) {
            swiperParams.pagination = {
                el: '.swiper-pagination',
            };
        }
        if (selectorItem.getAttribute('data-swiper-scrollbar')) {
            swiperParams.scrollbar = {
                el: '.swiper-scrollbar',
            };
        }
        MoyaEventHandler.dispatch('carousel', {
            options: swiperParams,
            el: el,
        });
        new swiper.Swiper(selector, swiperParams);
    });

}(window));
typeof tsBuild === 'function' && tsBuild();})();
